"use client"

import { useUpsertEventSubscribers } from "@/(admin)/modules/subscriber/hooks/useUpsertEventSubscriber"
import { FormSection, FormShell, FormSkeleton, StickyActionBar } from "@/(admin)/components/form"
import AccessDenied from "@/components/custom-access-denied"
import { EVENT_SUBSCRIBERS } from "@/constants/admin-paths"
import { useCheckPermission } from "@/hook/use-check-permission"
import { t } from "@/languages/i18n"
import { SaveOutlined } from "@ant-design/icons"
import { Button } from "antd"
import EventSubscriberUpsertForm from "./EventSubscriberUpsertForm"

const UpsertEventSubscriber = () => {
  const { form, isEditMode, loading, submitting, isChange, handlers, eventOptions } = useUpsertEventSubscribers()

  const { hasPermission: checkPermission } = useCheckPermission()

  const requiredPermission = isEditMode ? "update" : "create"

  if (!checkPermission("subscriber", requiredPermission)) {
    return <AccessDenied />
  }

  if (loading && isEditMode) {
    return <FormSkeleton mainSections={2} sidebarCards={0} />
  }

  const crumbs = [
    { title: t("Người đăng ký"), href: `/admin${EVENT_SUBSCRIBERS.LIST.PATH}` },
    { title: isEditMode ? t("Chỉnh sửa") : t("Tạo mới") },
  ]

  const main = (
    <FormSection title={t("Thông tin đăng ký")} collapsible={false}>
      <EventSubscriberUpsertForm form={form} onFormChange={handlers.handleFormChange} eventOptions={eventOptions} />
    </FormSection>
  )

  const actionBar = (
    <StickyActionBar
      right={
        <>
          <Button onClick={handlers.handleBack}>{t("Cancel")}</Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            loading={submitting}
            disabled={isEditMode ? !isChange : false}
            onClick={handlers.handleSubmit}
          >
            {isEditMode ? t("Update") : t("Create")}
          </Button>
        </>
      }
    />
  )

  return (
    <FormShell
      title={isEditMode ? t("Edit event subscriber") : t("Add event subscriber")}
      crumbs={crumbs}
      main={main}
      actionBar={actionBar}
    />
  )
}

export default UpsertEventSubscriber
